import React from "react";
import ProductCard from "../components/ProductCard";
import Layout from "../components/Layout";
import styles from "./Atlantic.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const atlanticProducts = [
  // --- VALMIS ---
  { key: "valmis_sardine_oil_240", image: "/assets/products/canned/atlantic/atlantic-valmis-sardine-oil-240.jpg" },
  { key: "valmis_mackerel_oil_240", image: "/assets/products/canned/atlantic/atlantic-valmis-mackerel-oil-240.jpg" },
  { key: "valmis_pink_salmon_natural_240", image: "/assets/products/canned/atlantic/atlantic-valmis-pink-salmon-natural-240.jpg" },
  { key: "valmis_salmon_juice_240", image: "/assets/products/canned/atlantic/atlantic-valmis-salmon-in-juice-240.jpg" },

  // --- BALTIC SEA / VENTSPILS ---
  { key: "baltic_riga_sardine_oil_240", image: "/assets/products/canned/atlantic/atlantic-baltic-sea-riga-sardine-oil-240.jpg" },
  { key: "ventspils_riga_sardine_oil_240", image: "/assets/products/canned/atlantic/atlantic-ventspils-riga-sardine-oil-240.jpg" },
  { key: "ventspils_mackerel_oil_240", image: "/assets/products/canned/atlantic/atlantic-ventspils-mackerel-oil-240.jpg" },
  { key: "ventspils_pink_salmon_natural_240", image: "/assets/products/canned/atlantic/atlantic-ventspils-pink-salmon-natural-240.jpg" },
];

const Atlantic = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <h2 className={styles.heading}>{t("atlantic.title")}</h2>

      <div className={styles.grid}>
        {atlanticProducts.map((product) => (
          <ProductCard
            key={product.key}
            title={t(`atlantic.products.${product.key}.title`)}
            weight={t(`atlantic.products.${product.key}.weight`)}
            description={t(`atlantic.products.${product.key}.description`)}
            image={product.image}
          />
        ))}
      </div>
    </Layout>
  );
};

export default Atlantic;
